import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class Paragraph extends PureComponent {
  render() {
    const { className, text } = this.props;

    return /<a|br[\s\S]*>/.test(text) ? (
      <span className={className} dangerouslySetInnerHTML={{ __html: text }} />
    ) : (
      <span className={className}>{text}</span>
    );
  }
}

Paragraph.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string
};

Paragraph.defaultProps = {
  className: "",
  text: ""
};

export default Paragraph;



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js